export const partyTypes = [
  {
    value: 'Petitioner',
    label: 'Petitioner',
  },
  {
    value: 'Respondent',
    label: 'Respondent',
  },
];
